import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { useInputValue } from '../../../../hooks';
import useCreateGitLabInstance from '../../../../hooks/api/settings/integrations/useCreateGitLabInstance';
import { ButtonGroup } from '../../../generic';
import Button, { LoaderButton } from '../../../generic/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledPasswordInput from '../../../generic/Forms/LabeledPasswordInput';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';

type Props = {
  isShowing: boolean;
  onHide: () => void;
};

const GitLabInstanceModal: VoidFunctionComponent<Props> = ({ isShowing, onHide }) => {
  const [name, setName] = useInputValue('');
  const [baseUrl, setBaseUrl] = useInputValue('');
  const [clientId, setClientId] = useInputValue('');
  const [clientSecret, setClientSecret] = useInputValue('');

  const resetAndHide = () => {
    setName('');
    setBaseUrl('');
    setClientId('');
    setClientSecret('');

    onHide();
  };

  const isButtonDisabled = !name || !baseUrl || !clientId || !clientSecret;

  const { mutate: createInstance, isPending: isCreating } = useCreateGitLabInstance(resetAndHide);

  const isLoading = isCreating;

  const handleSubmit = async () => {
    createInstance({ name, baseUrl, clientId, clientSecret });
  };

  return (
    <Modal
      show={isShowing}
      onHide={onHide}
    >
      <Modal.Header>Add GitLab Instance</Modal.Header>
      <Modal.Body>
        <FormGroup>
          <LabeledTextInput labelVariant="legacy" label="Name" value={name} onChange={setName} />
          <LabeledTextInput labelVariant="legacy" label="Base URL" value={baseUrl} onChange={setBaseUrl} placeholder="https://gitlab.example.com" />
          <LabeledTextInput labelVariant="legacy" label="Client ID" value={clientId} onChange={setClientId} />
          <LabeledPasswordInput
            label="Client Secret"
            value={clientSecret}
            onChange={setClientSecret}
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            type="secondary"
            onClick={resetAndHide}
          >
            Cancel
          </Button>
          <LoaderButton
            type="primary"
            isLoading={isLoading}
            isDisabled={isButtonDisabled}
            onClick={handleSubmit}
          >
            Add Instance
          </LoaderButton>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default GitLabInstanceModal;
